import React from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { LoadingOverlay } from "@achmadk/react-loading-overlay";
import { useAtomValue } from "jotai";
import { ReactFlowProvider } from "reactflow";

import router from "./routers";
import { showOverlayLoadingAtom } from "./config/state";

function App() {
  const showOverlayLoading = useAtomValue(showOverlayLoadingAtom);

  return (
    <ReactFlowProvider>
      <RouterProvider router={router} />

      <Toaster />
      <LoadingOverlay
        spinner
        active={showOverlayLoading}
        text="لطفا منتظر باشید..."
        fadeSpeed={200}
        styles={{
          overlay: (base) => ({
            ...base,
            position: "fixed",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 99999999,
          }),
          spinner: (base) => ({
            ...base,
            marginBottom: "20px",
          }),
        }}
      />
    </ReactFlowProvider>
  );
}

export default App;
